import { Record, Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import * as actions from './actions'
import * as levelsActions from '../levels/actions'
import * as activitiesActions from '../activities/actions'
import { replaceActivity } from 'store/entities/generator/actions'

export const UnsavedChanges = Record({
  blockedPathName: null,
  touched: Map({
    levels: false,
    activities: false,
  }),
})

const handleSetBlockedPathname = (state, { payload }) => {
  return state.set('blockedPathName', payload.pathname)
}

const handleSetLevelsTouched = state => {
  return state.setIn(['touched', 'levels'], true)
}

const handleSetActivitiesTouched = state => {
  return state.setIn(['touched', 'activities'], true)
}

const handleReset = () => new UnsavedChanges()

export default handleActions(
  {
    [actions.setBlockedPathname]: handleSetBlockedPathname,
    [actions.reset]: handleReset,
    [combineActions(levelsActions.setOrder, levelsActions.setDeleted)]: handleSetLevelsTouched,
    [combineActions(
      activitiesActions.setOrder,
      activitiesActions.setDeleted,
      activitiesActions.setPinned,
      activitiesActions.addActivitiesFromFile,
      replaceActivity
    )]: handleSetActivitiesTouched,
  },
  new UnsavedChanges()
)
